import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_DEV } from "../consts.js"

export const madera = {
	// Dev
	"madera-poc-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_DEV }
}
